import Event from "./event";
import Notify from "./../notify";
(function($) {
    var event = new Event();

    var ajaxLinkEvent = "/themes/ahtilahti/ajax/event_actions.php";
    var deleteClass = ".delete-event";
    var deleteClassInner = ".delete-event-inner";
    var copyClass = ".copy-event";
    var stopSellTickets = ".stop-sell-tickets";
    var startSellTickets = ".start-sell-tickets";
    var stopSellCert = ".stop-sell-cert";
    var startSellCert = ".start-sell-cert";

    var ajaxLinkSession = "/themes/ahtilahti/ajax/event_sessions.php";
    var deleteSession = ".session-delete";
    var deleteSessionInner = ".session-delete-inner";
    var stopSellSession = ".session-stop-sell";
    var startSellSession = ".session-start-sell";

    var ajaxEditEvent = "/themes/ahtilahti/ajax/event_edit.php";
    var eventEditReturnLink = ".event-return-button";
    var eventEditDeleteLink = ".event-delete-button";
    var editFormEvent = ".event-form-edit";
    var editFormSession = ".session-form-edit";

    var ajaxLinkObject = "/themes/ahtilahti/ajax/object_actions.php";
    var objectDeleteLink = ".arenda-object-delete";
    var objectCopy = ".copy-arend";
    var startObjectArend = ".arenda-object-start";
    var stopObjectArend = ".arenda-object-stop";

    var ajaxLinkOrder = "/themes/ahtilahti/ajax/orders_actions.php";
    var deleteOrder = ".order-delete";
    var stopSessionOrder = ".order-stop-session";
    var ticketSendOrder = ".order-ticket-send";
    var ticketSendOrderAnotherEmail = ".order-ticket-send-another-email";

    var editFormControlSession = ".event-control-session-edit";

    var ajaxObjectOrder = "/themes/ahtilahti/ajax/orders_object.php";
    var objectOrderToggleEmailForm = ".object-order-form-toggle";
    var objectAnotherEmailEventForm = ".object-another-email-form";
    var objectOrderEmailEvent = ".object-order-send-email";
    var objectOrderCansel = ".object-order-cancel";

    // Locations 
    var ajaxLinkLocation = "/themes/ahtilahti/ajax/locations/handler.php";
    var locationDelete = ".location-delete";

    // Проверка выполнения действия (удаления)

    function checkEventSuccess() {
        let container = $("#event-modal-success");
        $(".event-close-modal-success").on("click", function(e) {
            e.preventDefault();
            container.hide(150);
        });
        container.show(150);
        let timer = document.createElement("span");
        let seconds = 5;
        timer.innerHTML = seconds;
        $("#event-modal-timer").html(timer);
        $(".event-seconds-action").css({ "color": "#58cc64" });
        $(".event-seconds-action").html(timer);

        return new Promise(resolve => {

            let interval = setInterval(function() {

                if (seconds >= 4 && seconds <= 5) {
                    $(".event-seconds-action").css({ "color": "#58cc64" });
                }
                if (seconds >= 2 && seconds <= 4) {
                    $(".event-seconds-action").css({ "color": "#eeb301" });
                }
                if (seconds >= 0 && seconds <= 2) {
                    $(".event-seconds-action").css({ "color": "#a53b2a" });
                }

                --seconds;

                if (seconds == 0) {
                    timer.innerHTML = seconds;
                    container.hide(150);
                    clearInterval(interval);
                    resolve();
                }

                timer.innerHTML = seconds;

            }, 1000);

            $(".event-cancel-action").on("click", function(e) {
                e.preventDefault();
                clearInterval(interval);
                container.hide(150);
            });
        });
        return new Promise(resolve => {});
    }

    function sendQueryEvent(action, data, successMessage, errorMessage, url) {
        var flag = {
            success: false,
            link: "",
            message: "",
            reload: true,
        };
        $.ajax({
            method: "POST",
            url: url,
            async: false,
            data: {
                action: action,
                data: {
                    id: data,
                },
            },
            success: function(response) {

                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);
                if (res.success) {
                    flag.success = true;

                    if (res.link) {
                        flag.link = res.link;
                    }
                    if (res.reload == false) {
                        flag.reload = res.reload;
                    }
                    if (res.message) {
                        let type = res.type ? res.type : "success";
                        new Notify(res.message, type);
                        flag.message = res.message;
                    } else {
                        new Notify(successMessage, "success");
                    }
                } else {
                    new Notify(errorMessage, "alert");
                }
            },
            error(xhr, status, error) {
                new Notify(error, "alert");
            },
        });

        return flag;
    }
    // Удалить мероприятие
    $(document).on("click", deleteClass, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            checkEventSuccess().then(() => {
                var result = sendQueryEvent(
                    "delete-event",
                    materialId,
                    "Мероприятие успешно удалено",
                    "Ошибка удаления",
                    ajaxLinkEvent
                );
                if (result.success) {
                    $("#" + materialId).detach();
                }
            });


        }
    });
    // Удалить мероприятие внутри мероприятия
    $(document).on("click", deleteClassInner, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            checkEventSuccess().then(() => {
                var result = sendQueryEvent(
                    "delete-event",
                    materialId,
                    "Мероприятие успешно удалено",
                    "Ошибка удаления",
                    ajaxLinkEvent
                );
                if (result.success) {
                    document.location.href = "/";
                }
            });
        }
    });

    // Копировать мероприятие
    $(document).on("click", copyClass, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            var result = sendQueryEvent(
                "copy-event",
                materialId,
                "Мероприятие успешно скопировано",
                "Ошибка копирования",
                ajaxLinkEvent
            );

            if (result.success) {
                if (result.link) {
                    setTimeout(() => {
                        document.location.href = result.link;
                    }, 500);
                }
            }
        }
    });

    // Остановить продажу билетов
    $(document).on("click", stopSellTickets, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            var result = sendQueryEvent(
                "stop-tickets",
                materialId,
                "Продажа билетов остановлена",
                "Ошибка остановки продажи билетов",
                ajaxLinkEvent
            );
            if (result.success) {
                if (result.reload) {
                    setTimeout(() => {
                        document.location.reload();
                    }, 500);
                }
            }
        }
    });
    // Запустить продажу билетов
    $(document).on("click", startSellTickets, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            var result = sendQueryEvent(
                "start-tickets",
                materialId,
                "Продажа билетов запущена",
                "Ошибка запуска продажи билетов",
                ajaxLinkEvent
            );
            if (result.success) {
                if (result.reload) {
                    setTimeout(() => {
                        document.location.reload();
                    }, 500);
                }
            }
        }
    });

    // Удалить сеанс
    $(document).on("click", deleteSession, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");

        if (materialId) {
            checkEventSuccess().then(() => {
                var result = sendQueryEvent(
                    "delete-session",
                    materialId,
                    "Сеанс успешно удален",
                    "Ошибка удаления сеанса",
                    ajaxLinkSession
                );
                if (result.success) {
                    $("#" + materialId).detach();
                }
            });
        }
    });
    // Удалить сеанс (внутри)
    $(document).on("click", deleteSessionInner, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");

        if (materialId) {
            checkEventSuccess().then(() => {
                var result = sendQueryEvent(
                    "delete-session",
                    materialId,
                    "Сеанс успешно удален",
                    "Ошибка удаления сеанса",
                    ajaxLinkSession
                );
                if (result.success) {
                    if (result.link) {
                        setTimeout(() => {
                            document.location.href = result.link;
                        }, 500);
                    }
                }
            });
        }
    });

    // Остановить продажу сеанса
    $(document).on("click", stopSellSession, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            var result = sendQueryEvent(
                "stop-sell-sesson",
                materialId,
                "Продажа сеанса остановлена",
                "Ошибка остановки продажи сеанса",
                ajaxLinkSession
            );
            if (result.success) {
                setTimeout(() => {
                    document.location.reload();
                }, 500);
            }
        }
    });

    // Запустить продажу сеанса
    $(document).on("click", startSellSession, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            var result = sendQueryEvent(
                "start-sell-sesson",
                materialId,
                "Продажа сеанса запущена",
                "Ошибка запуска продажи сеанса",
                ajaxLinkSession
            );
            if (result.success) {
                setTimeout(() => {
                    document.location.reload();
                }, 500);
            }
        }
    });

    // Для сертификатов

    $(document).on("click", stopSellCert, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        sendQueryEvent(
            "stop-cert",
            materialId,
            "Продажа сертификатов успешно остановлена",
            "Ошибка остановки продажи сертификатов",
            ajaxLinkEvent
        );
    });

    $(document).on("click", startSellCert, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        sendQueryEvent(
            "start-cert",
            materialId,
            "Продажа сертификатов успешно запущена",
            "Ошибка запуска продажи сертификатов",
            ajaxLinkEvent
        );
    });

    // Редактировать мероприятие

    // Кнопка "Отменить"
    $(document).on("click", eventEditReturnLink, function(e) {
        e.preventDefault();
        window.history.back();
    });

    // Кнопка  "Удалить";
    $(document).on("click", eventEditDeleteLink, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            checkEventSuccess().then(() => {
                var result = sendQueryEvent(
                    "delete-event",
                    materialId,
                    "Мероприятие успешно удалено",
                    "Ошибка удаления",
                    ajaxLinkEvent
                );
                if (result.success) {
                    document.location.href = "/";
                }
            });
        }
    });

    // Редактирование мероприятия
    $(document).on("submit", editFormEvent, function(e) {
        e.preventDefault();
        var addres = $("#addres");
        addres.removeAttr("disabled");
        var id = $(this).data("item");
        var data = $(this).serializeArray();
        addres.attr("disabled", "disabled");
        let requiredError = false;

        data.forEach((element) => {
            var el = $("[name=" + element.name + "]");
            var required = el.attr("data-required");

            if (required == "Y") {
                if (!element.value.trim() || element.value.trim().length == 0) {
                    el.addClass("callout alert");
                    requiredError = true;
                } else {
                    el.removeClass("callout alert");
                }
            }
        });

        if (requiredError) {
            new Notify("Пожалуйста, Заполните обязательные поля", "alert");
        } else {
            $.ajax({
                method: "POST",
                url: ajaxEditEvent,
                data: {
                    action: "edit_event",
                    data: {
                        data: data,
                        id: id,
                    },
                },
                success: function(response) {
                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);

                    if (res.success) {
                        new Notify(res.message, "success");
                    } else {
                        new Notify(res.message, "alert");
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });
        }
    });

    // Редактирование сеанса | отправка формы редактирования

    //
    $(".session-check-current").on("change", function() {
        if ($(this).is(":checked")) {
            if ($(".session-check-all").is(":checked")) {
                $(".session-check-all").prop("checked", false);
            }
        }
    });

    $(".session-check-all").on("change", function() {
        if ($(this).is(":checked")) {
            if ($(".session-check-current").is(":checked")) {
                $(".session-check-current").prop("checked", false);
            }
        }
    });

    $(document).on("submit", editFormSession, function(e) {
        e.preventDefault();
        let id = $(this).data("item");
        let data = $(this).serializeArray();
        let service = {};
        let common = {};
        let sessions = [];
        let requiredError = false;
        let all = "";
        data.forEach((element) => {
            var el = $("[name=" + element.name + "]");
            var required = el.attr("data-required");

            if (required == "Y") {
                if (!element.value.trim() || element.value.trim().length == 0) {
                    el.addClass("callout alert");
                    requiredError = true;
                } else {
                    el.removeClass("callout alert");
                }
            }

            if (element.name.indexOf("service") != -1) {
                let indexElement = element.name.split("-")[2];

                if (typeof service[indexElement] !== "object") {
                    service[indexElement] = {};
                }

                if (element.name.indexOf("service-name") != -1) {
                    service[indexElement]["service-name"] = [];
                    service[indexElement]["service-name"] = element.value;
                }

                if (element.name.indexOf("service-price") != -1) {
                    service[indexElement]["service-price"] = [];
                    service[indexElement]["service-price"] = element.value;
                }

                if (element.name.indexOf("service-count") != -1) {
                    service[indexElement]["service-count"] = [];
                    service[indexElement]["service-count"] = element.value;
                }

                if (
                    $("[data-item='" + indexElement + "']").attr("data-delete") == "Y"
                ) {
                    service[indexElement]["service-delete"] = [];
                    service[indexElement]["service-delete"] = "Y";
                }

                if (
                    $("[data-item='" + indexElement + "']").attr("data-create") == "Y"
                ) {
                    service[indexElement]["service-create"] = [];
                    service[indexElement]["service-create"] = "Y";
                }
            } else if (element.name.indexOf("session") != -1) {
                let indexElement = element.name.split("-")[1];
                sessions.push(indexElement);
            } else if (element.name == "all") {
                all = element.value;
            } else {
                common[element.name] = [];
                common[element.name] = element.value;
            }
        });

        if (requiredError) {
            new Notify("Пожалуйста, Заполните обязательные поля", "alert");
        } else {
            $.ajax({
                method: "POST",
                url: ajaxLinkSession,
                data: {
                    action: "edit-session",
                    data: {
                        id: id,
                        common: common,
                        service: service,
                        sessions: sessions,
                        all: all,
                    },
                },
                success: function(response) {
                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {
                        new Notify(res.message, "success");
                    } else {
                        new Notify(res.message, "alert");
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });
        }
    });

    // Скрытие услуг для удаления внутри редактирования сеанса

    $(".service-delete-edit").on("click", function(e) {
        e.preventDefault();

        let parentElement = $(this).closest(".service-element");
        parentElement.attr("data-delete", "Y");
        parentElement.addClass("hide");
    });
    // Выпадашки для кнопок в управлении сессиями

    //   $(".del-button").each((index, element) => {
    //     let dropdowEvent = $(element).attr("data-toggle");
    //     new Foundation.Dropdown($("#" + dropdowEvent));
    // });

    // Скрытие сеансов для удаления внутри управления сессиями

    $(".session-control-delete").on("click", function(e) {
        e.preventDefault();
        let parentElement = $(this).closest(".session__item");
        parentElement.attr("data-delete", "Y");
        parentElement.addClass("hide");
    });

    // Календарь "один или несколько дней сеанса" в управлении сеансами

    $(".event-multidates-input--control").each(function() {
        event.initMultipleDate($(this)[0]);
    });
    // Календарь "Или дни сеанса " в управлении сеансами

    $(".event-period--control").each(function() {
        let datesString = $(this).val();
        let datesArray = datesString.split("-");

        let range = event.initRangeDate($(this)[0]);
        if (datesArray[0] && datesArray[1]) {
            range.setDateRange(datesArray[0].trim(), datesArray[1].trim());
        }
    });

    //  Отправка формы в управлении сеансами

    $(editFormControlSession).on("submit", function(e) {
        e.preventDefault();
        let formId = $(this).attr("data-item");

        let requiredError = event.collectDate(this);

        let sessions = event.serializeArray.sessions;

        for (let item in sessions) {
            let element = $(".session__item-control-" + item);
            let del = element.attr("data-delete");
            let create = element.attr("data-create");

            if (del) {
                sessions[item]["action-delete"] = [];
                sessions[item]["action-delete"] = del;
            }

            if (create) {
                sessions[item]["action-create"] = [];
                sessions[item]["action-create"] = create;
            }
        }

        if (requiredError == false) {
            $.ajax({
                method: "POST",
                url: ajaxLinkSession,
                async: false,
                data: {
                    action: "edit-session-control",
                    data: {
                        id: formId,
                        sessions: sessions,
                    },
                },
                success: function(response) {
                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {
                        new Notify(res.message, "success");
                        for (var session in sessions) {
                            $(".session__item-control-" + session).removeAttr("data-create");
                        }
                    } else {
                        new Notify(res.message, "alert");
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });
        } else {
            event.alertErrorEmpty();
        }
    });

    // Объекты
    // Удалить объект
    $(document).on("click", objectDeleteLink, function(e) {
        e.preventDefault();
        let elem = this;
        var materialId = $(this).data("item");

        if (materialId) {

            $.ajax({
                method: "POST",
                url: ajaxLinkObject,
                async: false,
                data: {
                    action: "check-ordered-object",
                    data: {
                        id: materialId,
                    },
                },
                success: function(response) {


                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {

                        if (!modalDelete) {
                            var modalDelete = new Foundation.Reveal($("#confirm-delete-object"));
                            modalDelete.open();
                        } else {
                            modalDelete.open();
                        }
                        $(document).on("click", "#confirm-delete-object-line-yes", function(e) {
                            checkEventSuccess().then(() => {
                                var result = sendQueryEvent(
                                    "delete-object",
                                    materialId,
                                    "Объект успешно удален",
                                    "Ошибка удаления объекта",
                                    ajaxLinkObject
                                );
                                if (result.success) {
                                    $("#" + materialId).detach();
                                }
                            });
                            modalDelete.close();
                            return;
                        });

                        $(document).on("click", "#confirm-delete-object-line-no", function(e) {
                            e.preventDefault();
                            modalDelete.close();
                            return;
                        });

                    } else {
                        // checkEventSuccess().then(() => {
                        var result = sendQueryEvent(
                            "delete-object",
                            materialId,
                            "Объект успешно удален",
                            "Ошибка удаления объекта",
                            ajaxLinkObject
                        );
                        if (result.success) {
                            $("#" + materialId).detach();
                        }
                        // });
                    }
                    return;
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });


        }
    });
    // Остановить аренду объекта
    $(document).on("click", stopObjectArend, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {

            $.ajax({
                method: "POST",
                url: ajaxLinkObject,
                async: false,
                data: {
                    action: "check-ordered-object-for-stop",
                    data: {
                        id: materialId,
                    },
                },
                success: function(response) {


                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {
                        if (!modalStop) {
                            var modalStop = new Foundation.Reveal($("#confirm-stoped-object"));
                            modalStop.open();
                        } else {
                            modalStop.open();
                        }
                        $(document).on("click", "#confirm-stoped-object-yes", function(e) {
                            checkEventSuccess().then(() => {
                                var result = sendQueryEvent(
                                    "stop-arend-object",
                                    materialId,
                                    "Аренда объекта остановлена",
                                    "Ошибка остановки аренды объекта",
                                    ajaxLinkObject
                                );
                                if (result.success) {
                                    setTimeout(() => {
                                        document.location.reload();
                                    }, 500);
                                }

                            });
                            modalStop.close();
                            return;
                        });

                        $(document).on("click", "#confirm-stoped-object-no", function(e) {
                            e.preventDefault();
                            modalStop.close();
                            return;
                        });

                    } else {
                        // checkEventSuccess().then(() => {
                        var result = sendQueryEvent(
                            "stop-arend-object",
                            materialId,
                            "Аренда объекта остановлена",
                            "Ошибка остановки аренды объекта",
                            ajaxLinkObject
                        );
                        if (result.success) {
                            setTimeout(() => {
                                document.location.reload();
                            }, 500);
                        }

                        // });
                        return;
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });


        }
    });

    // Запустить аренду объекта
    $(document).on("click", startObjectArend, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {


            $.ajax({
                method: "POST",
                url: ajaxLinkObject,
                async: false,
                data: {
                    action: "check-dates-for-start",
                    data: {
                        id: materialId,
                    },
                },
                success: function(response) {


                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {

                        // checkEventSuccess().then(() => {

                        var result = sendQueryEvent(
                            "start-arend-object",
                            materialId,
                            "Аренда объекта запущена",
                            "Ошибка запуска аренды объекта",
                            ajaxLinkObject
                        );
                        if (result.success) {
                            setTimeout(() => {
                                document.location.reload();
                            }, 500);
                        }

                        // });
                        return;


                    } else {
                        if (!modalStart) {
                            var modalStart = new Foundation.Reveal($("#error-object-start-arend"));
                            modalStart.open();
                        } else {
                            modalStart.open();
                        }
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });
        }
    });


    // Копировать объект
    $(document).on("click", objectCopy, function(e) {
        e.preventDefault();
        var materialId = $(this).data("item");
        if (materialId) {
            var result = sendQueryEvent(
                "copy-object",
                materialId,
                "Объект успешно скопировано",
                "Ошибка копирования",
                ajaxLinkObject
            );

            if (result.success) {
                if (result.link) {
                    setTimeout(() => {
                        document.location.href = result.link;
                    }, 500);
                }
            }
        }
    });




    // Кнопка  "Удалить" Локация;
    $(document).on("click", locationDelete, function(e) {

        e.preventDefault();

        var locationId = $(this).data("item");
        if (locationId) {
            $.ajax({
                method: "POST",
                url: ajaxLinkLocation,
                async: false,
                data: {
                    action: "checkDelete",
                    data: {
                        id: locationId,
                    },
                },
                success: function(response) {

                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {

                        checkEventSuccess().then(() => {
                            var result = sendQueryEvent(
                                "delete",
                                locationId,
                                "Заказ успешно удален",
                                "Ошибка удаления",
                                ajaxLinkLocation
                            );
                            if (result.success) {
                                $("#" + locationId).detach();
                            }
                        });
                    } else {
                        new Notify("Невозможно удалить локацию, у которой есть активные объекты", "alert");
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });
        }

        //     $.ajax({
        //         method: "POST",
        //         url: ajaxLinkLocation,
        //         async: false,
        //         data: {
        //             action: "checkDelete",
        //             data: {
        //                 id: materialId,
        //             },
        //         },
        //         success: function(response) {

        //         }


        // });
    });



    // Кнопка  "Удалить" заказ;
    $(document).on("click", deleteOrder, function(e) {
        e.preventDefault();
        var orderId = $(this).data("item");
        if (orderId) {
            checkEventSuccess().then(() => {
                var result = sendQueryEvent(
                    "delete-order",
                    orderId,
                    "Заказ успешно удален",
                    "Ошибка удаления",
                    ajaxLinkOrder
                );
                if (result.success) {
                    $("#" + orderId).detach();
                }
            });
        }
    });

    // Кнопка  "Отправить билет заново" заказа;
    $(document).on("click", ticketSendOrder, function(e) {
        e.preventDefault();
        var orderId = $(this).data("item");
        if (orderId) {
            var result = sendQueryEvent(
                "send-ticket-order",
                orderId,
                "Билет успешно отправлен",
                "Ошибка отправки билета",
                ajaxLinkOrder
            );
            if (result.success) {
                // empty
            }
        }
    });
    // Кнопка  "Отправить билет на другой email" заказа;
    $(document).on("click", ticketSendOrderAnotherEmail, function(e) {
        e.preventDefault();
        var orderId = $(this).data("item");
        if (orderId) {
            $("#another-form-email-" + orderId).toggleClass("hide");
            $("#another-form-email-" + orderId + " form").on("submit", function(e) {
                e.preventDefault();
                let data = $(this).serializeArray();

                $.ajax({
                    method: "POST",
                    url: ajaxLinkOrder,
                    data: {
                        action: "order-ticket-send-another-email",
                        data: {
                            data: data,
                            id: orderId,
                        },
                    },
                    success: function(response) {
                        let res;
                        typeof response === "string" ?
                            (res = $.parseJSON(response)) :
                            (res = response);
                        if (res.success) {
                            new Notify(
                                "Билет успешно отправлен по адресу: " + res.email,
                                "success"
                            );
                        } else {
                            new Notify("Ошибка отправки билета", "alert");
                        }
                    },
                    error(xhr, status, error) {
                        new Notify(error, "alert");
                    },
                });
            });
        }
    });

    // Кнопка  "Остановить сессию" заказа;
    $(document).on("click", stopSessionOrder, function(e) {
        e.preventDefault();
        var orderId = $(this).data("item");
        if (orderId) {
            var result = sendQueryEvent(
                "stop-sesson-order",
                orderId,
                "Сессия успешно  остановлена",
                "Ошибка остановки  сессии",
                ajaxLinkOrder
            );
            if (result.success) {
                // empty
            }
        }
    });

    // Отменить заказ аренды
    $(document).on("click", objectOrderCansel, function(e) {
        e.preventDefault();
        var orderId = $(this).data("item");

        if (orderId) {
            checkEventSuccess().then(() => {
                var result = sendQueryEvent(
                    "object-order-cancel",
                    orderId,
                    "Заказ успешно отменен",
                    "Ошибка отмены заказа",
                    ajaxObjectOrder
                );
                if (result.success) {
                    if (result.reload) {
                        setTimeout(() => {
                            document.location.reload();
                        }, 500);
                    }
                }
            });
        }



    });
    // Открыть поле отправки уведомления на другой email
    $(document).on("click", objectOrderToggleEmailForm, function(e) {
        e.preventDefault();
        let orderId = $(this).data("item");
        $("#another-form-email-" + orderId).toggleClass("hide");
    });

    // Открыть поле отправки уведомления на другой email
    $(document).on("submit", objectAnotherEmailEventForm, function(e) {
        e.preventDefault();
        let orderId = $(this).data("item");
        $("#another-form-email-" + orderId).toggleClass("hide");
        if (orderId) {
            let data = $(this).serializeArray();

            $.ajax({
                method: "POST",
                url: ajaxObjectOrder,
                data: {
                    action: "object-email-send-another",
                    data: {
                        data: data,
                        id: orderId,
                    },
                },
                success: function(response) {
                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {
                        new Notify(
                            "Уведомление успешно отправлено по адресу: " + res.email,
                            "success"
                        );
                    } else {
                        new Notify("Ошибка отправки уведомления", "alert");
                    }
                },
                error(xhr, status, error) {
                    new Notify(error, "alert");
                },
            });
        }
    });

    // Отправка другого email для уведомления
    $(document).on("click", objectOrderEmailEvent, function(e) {
        e.preventDefault();
        var orderId = $(this).data("item");
        if (orderId) {
            var result = sendQueryEvent(
                "object-email-send",
                orderId,
                "Уведомление успешно отправлено",
                "Ошибка отправки уведомления",
                ajaxObjectOrder
            );
            if (result.success) {

                // empty
            }
        }
    });

})(jQuery);
// upd